<script>
  import { onMount } from "svelte"
  import { orderBy } from "lodash"
  import ExpandableCard from "@/components/ExpandableCard/ExpandableCard.svelte"
  import { _ } from "@/i18n"
  import { viewedNotifications } from "@/stores/stores"
  import { hasData, formatRecordsDate } from "./medicationUtils"
  import CardBody from "./_cardBody.svelte"
  import CardHeader from "./_cardHeader.svelte"
  import { clientSidePagination } from "@/utils/clientSidePagination.js"
  import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator.svelte"

  export let medicationInfo
  let noficationsIds = []
  const initialRowCount = 100
  let isLoading = true

  /* eslint no-use-before-define: ["error", { "variables": false }] */
  const updateDataProps = (newdataProps) => {
    dataProps = { ...dataProps, ...newdataProps }
  }

  const updateRowCount = () => (chunkSize) => {
    const { visibleRowCount } = dataProps
    updateDataProps({ visibleRowCount: visibleRowCount + chunkSize })
  }

  let dataProps = {
    data: [],
    id: "medications-all",
    visibleRowCount: initialRowCount,
    updater: updateRowCount(),
  }

  // TODO: Need to add more status to filter records into Active and Inactive category
  /**
   * Filters and sort the data of records
   */
  const filterAndSortData = () => {
    const allRecords = orderBy(
      medicationInfo,
      ["value.started", "value.medicationName"],
      ["desc", "asc"],
    ).map(formatRecordsDate)
    updateDataProps({ data: allRecords })
  }

  $: if (medicationInfo) {
    filterAndSortData()

    isLoading = false
  }

  /**
   * Add notification to the viewedNotifications Store
   */
  onMount(() => {
    noficationsIds = medicationInfo
      .filter((medication) => medication.value.notificationId)
      .map((medication) => medication.value.notificationId)
    viewedNotifications.add([...noficationsIds])
  })
</script>

{#if isLoading}
  <div class="spinner-wrapper">
    <LoadingIndicator indicatorTitle={$_("COMMON.LOADING")} />
  </div>
{:else if dataProps.data.length > 0}
  <div
    data-testid="all-list"
    use:clientSidePagination={{
      totalRows: dataProps.data.length,
      updater: dataProps.updater,
      listId: "medications-all",
    }}
  >
    <div id="medications-all">
      {#each dataProps.data.slice(0, dataProps.visibleRowCount) as { value: { medicationName, dosage, frequency, id, notificationId, ...medicationProperties } } (id)}
        <div>
          <div class="card medication-card">
            <ExpandableCard isBodyExist={hasData(medicationProperties)}>
              <span slot="header">
                <CardHeader
                  {medicationName}
                  {dosage}
                  {frequency}
                  {notificationId}
                />
              </span>
              <span slot="body">
                <CardBody {medicationProperties} />
              </span>
            </ExpandableCard>
          </div>
        </div>
      {/each}
    </div>
  </div>
{:else}
  <div class="no-record">
    {#if medicationInfo.length === 0}
      {$_("HR.NO_RECORD_FOUND_FOR_MEDICATIONS")}
    {/if}
  </div>
{/if}

<style lang="scss">
  .category {
    color: #555860;
    margin-top: 20px;
    display: none;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
  }

  .showCategory {
    display: block;
  }

  .medication-card {
    padding: 0;
    margin-top: 12px;
    flex-direction: column;
  }

  @media (max-width: 575.98px) {
    .card {
      border-radius: 8px;
    }
  }
</style>
